import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { BaseLoanTypeStore } from '../../stores/baseLoanTypeStore';
import { SinglePropertyQuoteBorrowerEntityInformationStore } from '../../stores/singleProperty/singlePropertyQuoteBorrowerEntityInformationStore';
import {
  BorrowerEntityInformationSteps,
  SelectEntityOption,
} from '../../utils/constants';
import { AddEntityCard } from './components/addEntityCard';
import { BorrowerInformationCard } from './components/borrowerInformationCard';
import { FicoAndExperienceCard } from './components/ficoAndExperienceCard';
import { SearchExistingEntity } from './components/searchExistingEntity';
import { SelectCitizenshipOptionCard } from './components/selectCitizenshipOptionCard';
import { SelectEntityOptionCard } from './components/selectEntityOptionCard';

export const BorrowerEntityInformationStepV2 = observer(
  ({ store }: { store: BaseLoanTypeStore }) => {
    const { borrowerInformationStore } = store;
    const { mainBorrowerFormStore } = borrowerInformationStore;
    const borrowerEntityInformationStore = store.borrowerEntityInformationStore as SinglePropertyQuoteBorrowerEntityInformationStore;

    const option = borrowerEntityInformationStore.selectEntityOption;

    const entityStep =
      borrowerEntityInformationStore.borrowerEntityInformationActiveStep;

    const citizenshipStatus =
      mainBorrowerFormStore.form.fields.citizenshipStatus.value;

    const fetchBorrowerData = async () => {
      await borrowerEntityInformationStore.fetchBorrowerAndEntityData();
    }

    useEffect(() => {
      fetchBorrowerData();
    }, []);

    const setOption = option => {
      borrowerEntityInformationStore.setSelectEntityOption(option);
      borrowerEntityInformationStore.goToNextSubstep();
    };

    useEffect(() => {
      if (entityStep === BorrowerEntityInformationSteps.BORROWER_CITIZENSHIP && borrowerInformationStore?.mainBorrower?.citizenshipStatus) {
        mainBorrowerFormStore.onFieldChange('citizenshipStatus', borrowerInformationStore?.mainBorrower?.citizenshipStatus);
        borrowerEntityInformationStore.goToNextSubstep();
      }
    }, [borrowerInformationStore?.mainBorrower?.citizenShipStatus, entityStep])

    return (
      <>
        {entityStep === BorrowerEntityInformationSteps.BORROWER_CITIZENSHIP && (
          <SelectCitizenshipOptionCard
            option={citizenshipStatus}
            onSelect={value => {
              mainBorrowerFormStore.onFieldChange('citizenshipStatus', value);
              borrowerEntityInformationStore.goToNextSubstep();
            }}
          />
        )}
        {entityStep === BorrowerEntityInformationSteps.BORROWER_CREDIT && (
          <FicoAndExperienceCard />
        )}
        {entityStep === BorrowerEntityInformationSteps.SELECT_ENTITY_OPTION && (
          <SelectEntityOptionCard option={option} onSelect={setOption} />
        )}
        {entityStep === BorrowerEntityInformationSteps.SEARCH_ENTITY && (
          <SearchExistingEntity />
        )}
        {entityStep === BorrowerEntityInformationSteps.ADD_ENTITY && (
          <AddEntityCard />
        )}
        {entityStep === BorrowerEntityInformationSteps.BORROWER_INFORMATION && (
          <BorrowerInformationCard />
        )}
      </>
    );
  }
);
